const unavailableReason = {
    MAINTENANCE: "Manutenção",
    EXPERTISE: "Perícia",
    SEIZURE: "Apreensão",
    LOSS: "Extravio",
}

export const unavailableReasonLabels = unavailableReason;

export const unavailableReasonOptions = Object.entries(unavailableReason).map(([value, label]) => ({value, label}));